/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Whakauru te HTML editor ataahua"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Kaitirotiro te whakaurutanga"
  },
  "action_to_take_b626a99a": {
    "message": "Mahi hei mahi:"
  },
  "add_8523c19b": {
    "message": "Tāpiri"
  },
  "add_a_caption_2a915239": {
    "message": "Tāpiri he tapanga"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Tāpiri kuputuhi alt mo te pakoko"
  },
  "add_another_f4e50d57": {
    "message": "Tāpiri tētahi atu"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Tāpiri CC/Ngā Tohuwai"
  },
  "add_image_60b2de07": {
    "message": "Tāpiri Āhua"
  },
  "add_one_9e34a6f8": {
    "message": "Tāpiri kotahi!"
  },
  "additional_considerations_f3801683": {
    "message": "Ētahi atu whakāro"
  },
  "address_applied_64269b0b": {
    "message": "Ka tono te wahitau"
  },
  "address_removed_fcb496e0": {
    "message": "Kua tangohia te wahitau"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Ko ngā hononga hono ki te URL kotahi me kotahi te hononga."
  },
  "aleph_f4ffd155": {
    "message": "Arepa"
  },
  "align_11050992": {
    "message": "Whakarārangi"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Whakahurihuri me ngā Rārangi"
  },
  "all_4321c3a1": {
    "message": "Katoa"
  },
  "all_apps_a50dea49": {
    "message": "Ngā Raraunga Katoa"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Tukua te tango pāpāho"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Tukua te tango tuhinga"
  },
  "alpha_15d59033": {
    "message": "Arepa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Whakarārangitia ā pū"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Kia kaua te kuputuhi huanga Alt e nui atu i te 120 ngā reta."
  },
  "alt_text_611fb322": {
    "message": "Alt Kuputuhi"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Hua tahi)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "He hapa i puta i te wā e pānui ana i te kōnae"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "I puta he hapa i te wā e hanga ana i te tono whatunga"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "He hapa i puta i te wā e tikiake ana i tō pāpāhō."
  },
  "and_7fcc2911": {
    "message": "Me"
  },
  "angle_c5b4ec50": {
    "message": "Koki"
  },
  "announcement_fb4cb645": {
    "message": "Pānui"
  },
  "announcement_list_da155734": {
    "message": "Rārangi Pānuitanga"
  },
  "announcements_a4b8ed4a": {
    "message": "Pānuitanga"
  },
  "apply_781a2546": {
    "message": "Tono"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Tonoa huringa ki nga ahuatanga katoa o tenei Ata Kaihanga Ata i te Akoranga"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nga huarahi te Tepe"
  },
  "approximately_e7965800": {
    "message": "Tata ki"
  },
  "apps_54d24a47": {
    "message": "Tono"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "E pono ana koe ki te whakakore? Kaore pea e tiakina ngā huringa i mahia e koe."
  },
  "arrows_464a3e54": {
    "message": "Pere"
  },
  "art_icon_8e1daad": {
    "message": "Toi Tohu"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "E tiaki i Hau aronga"
  },
  "assignment_976578a8": {
    "message": "Whakataunga"
  },
  "assignments_1e02582c": {
    "message": "Ngā Whakataunga"
  },
  "asterisk_82255584": {
    "message": "whetūriki"
  },
  "attributes_963ba262": {
    "message": "Huanga"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Orooro me te tāhopu ataata kaore i te tautokotia tēnā koa whakamahia he pūtirotiro rerekē."
  },
  "audio_options_feb58e2c": {
    "message": "Ororongo Kōwhiringa"
  },
  "audio_options_tray_33a90711": {
    "message": "Ororongo Kōwhiringa Paepae"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Kaitākaro ororongo mō { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Tiaki-aunoa ngā ihirangi kei te tiari. Kei te hiahia koe ki te uta i te tiaki-aunoa ihirangi?"
  },
  "available_folders_694d0436": {
    "message": "Ngā kōpaki e wātea ana"
  },
  "background_1bc88842": {
    "message": "Papamuri"
  },
  "backslash_b2d5442d": {
    "message": "Whakamuri"
  },
  "bar_ec63ed6": {
    "message": "Ārai"
  },
  "basic_554cdc0a": {
    "message": "Taketake"
  },
  "because_501841b": {
    "message": "No te mea"
  },
  "below_81d4dceb": {
    "message": "Raro"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Nui Porowhita"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomial Taurangi"
  },
  "black_4cb01371": {
    "message": "Pango"
  },
  "blue_daf8fea9": {
    "message": "Kikorangi"
  },
  "bold_applied_42d547b7": {
    "message": "Te tono maia"
  },
  "bold_removed_da474a5c": {
    "message": "Kua tangohia maia"
  },
  "border_5b08b06d": {
    "message": "Taitapa"
  },
  "bottom_15a2a9be": {
    "message": "Raro"
  },
  "bottom_third_5f5fec1d": {
    "message": "Raro Tuatoru"
  },
  "bowtie_5f9629e4": {
    "message": "Te here kopere"
  },
  "brick_f2656265": {
    "message": "Pereki"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Whakakore"
  },
  "cap_product_3a5265a6": {
    "message": "Hua potae"
  },
  "caption_manager_aae0906f": {
    "message": "Kaiwhakahaere Tapanga"
  },
  "center_align_e68d9997": {
    "message": "Tiaro Pokapū"
  },
  "centered_dot_64d5e378": {
    "message": "Pokapū Ira"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Pokapū Whakapae Ira"
  },
  "change_alt_text_92654906": {
    "message": "Huri kē alt kuputuhi"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Hurihia te pane tūtohu ki te parawae"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Hurihia te taumata o tenei upoko anake"
  },
  "change_text_color_1aecb912": {
    "message": "Huria te tae o te kuputuhi"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Ka pā ngā huringa i muri i tō tiaki i tēnei whārangi."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Kaore pea e tiakina ngā huringa i mahia e koe."
  },
  "characters_9d897d1c": {
    "message": "Nga pūāhua"
  },
  "characters_no_spaces_485e5367": {
    "message": "Pūāhua (karekau he mokowā)"
  },
  "check_accessibility_3c78211c": {
    "message": "Āta titiro te whakaurutanga"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Āta titiro mo ngā take whakauru"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Kōwhiria kōnae tapanga"
  },
  "choose_usage_rights_33683854": {
    "message": "Kōwhiria ngā mōtika whakamahi ..."
  },
  "circle_484abe63": {
    "message": "Porohita"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "Porohitatia te rārangi kore"
  },
  "clear_2084585f": {
    "message": "Ūkui"
  },
  "clear_image_3213fe62": {
    "message": "Maamaa whakaahua"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Pāwhiri ara neke rānei pāwhiri mo te html editor."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Pāwhiritia ki te whakaū i { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Pāwhiri ki te huna i te arokite"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Pāwhiritia ki te kōkuhu i tētahi hononga ki te ētita."
  },
  "click_to_show_preview_faa27051": {
    "message": "Pāwhiri ki te kite i te arokite"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Kati he tāhua kōrero rānei. Ka whakahoki anō ki te wāhi etita"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Kati Kaitirotiro Whakaurutanga"
  },
  "close_d634289d": {
    "message": "Katia"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Katia te Modal Pokatata Papapātuhi"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Katia ngā tapanga kōnae me iti ake i te { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Kua katia Ngā Tapanga/Ngā Tuhinga"
  },
  "clubs_suit_c1ffedff": {
    "message": "Karapu (Hutu)"
  },
  "collab_575ac7bc": {
    "message": "Mahi tahi"
  },
  "collaborations_5c56c15f": {
    "message": "Ngātahi"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Hinga ki te hunga { types }"
  },
  "color_a363e1b0": {
    "message": "Tae"
  },
  "color_contrast_4c418add": {
    "message": "Tauira Tae"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Tauwehenga Purata Tae"
  },
  "color_picker_6b359edf": {
    "message": "Kaiwhiri Tae"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Kaikōwhiri Tae ({ colorName } kua tohua)"
  },
  "color_popup_af39810f": {
    "message": "Pahūake tae"
  },
  "column_e1ae5c64": {
    "message": "Pou"
  },
  "column_group_1c062368": {
    "message": "Rōpū pou"
  },
  "complex_numbers_a543d004": {
    "message": "Matatini Tau He taurite"
  },
  "computer_1d7dfa6f": {
    "message": "Rorohiko"
  },
  "congruent_5a244acd": {
    "message": "Te here kopere"
  },
  "contains_311f37b7": {
    "message": "Kei roto"
  },
  "content_1440204b": {
    "message": "Ihirangi"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Ka hurihia te ihirangi o te ētita. Pēhia Whakakore kia mau tonu te ihirangi taketake."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Kei te tikiake tonu te ihirangi, ki te haere tonu koe kaore e tika te whakauru."
  },
  "content_subtype_5ce35e88": {
    "message": "Ihirangi subtype"
  },
  "content_type_2cf90d95": {
    "message": "Momo ihirangi"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Haere tonu ki te ihirangi YouTube"
  },
  "coproduct_e7838082": {
    "message": "Hua-tahi"
  },
  "copyright_holder_66ee111": {
    "message": "Kaimau Manatārua:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Kāore e taea te kōkuhu ihirangi: \"{ itemType }\" kaore i te tautokohia nga huānga e Canvas."
  },
  "count_40eced3b": {
    "message": "Tatau"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 ngā kupu}\n    one {1 kupu}\n  other {# ngā kupu}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# kua utaina te tuemi}\n  other {# kua nutainga ngā tuemi}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Ngā Akoranga Tuhinga"
  },
  "course_files_62deb8f8": {
    "message": "Ngā Kōnae Akoranga"
  },
  "course_files_a31f97fc": {
    "message": "Ngā kōnae akoranga"
  },
  "course_images_f8511d04": {
    "message": "Ngā Akoranga Āhua"
  },
  "course_link_b369426": {
    "message": "Hononga Akoranga"
  },
  "course_links_b56959b9": {
    "message": "Ngā Akoranga Hononga"
  },
  "course_media_ec759ad": {
    "message": "Akoranga Pāpāho"
  },
  "course_navigation_dd035109": {
    "message": "Whakaterenga Akoranga"
  },
  "create_icon_110d6463": {
    "message": "Waihanga Tohu"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Waihangahia Tohu Kaihanga Tohu"
  },
  "creative_commons_license_725584ae": {
    "message": "Auaha ngā Raihana Noa:"
  },
  "crop_image_41bf940c": {
    "message": "Whakatipu whakaahua"
  },
  "crop_image_807ebb08": {
    "message": "Tapahi Whakaahua"
  },
  "cup_product_14174434": {
    "message": "Hua Kapu"
  },
  "current_image_f16c249c": {
    "message": "Whakapakoko o Nāianei"
  },
  "current_link_945a47ee": {
    "message": "Hononga o naianei"
  },
  "current_volume_level_c55ab825": {
    "message": "Taumata o te rōrahi ōnāianei"
  },
  "custom_6979cd81": {
    "message": "Tikanga"
  },
  "cyan_c1d5f68a": {
    "message": "Kawariki"
  },
  "dagger_57e0f4e5": {
    "message": "Te hoari"
  },
  "date_added_ed5ad465": {
    "message": "Rā kua tāpiritia"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Whakapaipai Ata"
  },
  "decorative_image_fde98579": {
    "message": "Whakapaipai āhua"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Whakapaipai { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Nuku Whakaiti"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Whakahekea te Rohe Ihirangi Taonga"
  },
  "deep_purple_bb3e2907": {
    "message": "Hohonu Waiporoporo"
  },
  "default_9db103d": {
    "message": "Taunoa"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "Taunoa whakanuia rārangi kore"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "Taunoa tātai kua rārangitia"
  },
  "definite_integral_fe7ffed1": {
    "message": "Tūturu Tautoko"
  },
  "degree_symbol_4a823d5f": {
    "message": "Tohu Tohu"
  },
  "delimiters_4db4840d": {
    "message": "Ngā Kaiwehe"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Whakaahuahia te ata)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Whakaahuahia te { TYPE })"
  },
  "description_436c48d7": {
    "message": "Whakāhuatanga"
  },
  "details_98a31b68": {
    "message": "Ngā taipitopito"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Ira Hauroki"
  },
  "diamond_b8dfe7ae": {
    "message": "Taimana"
  },
  "diamonds_suit_526abaaf": {
    "message": "Taimana (Hutu)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Momo Ahu"
  },
  "directionality_26ae9e08": {
    "message": "Hangai tōtika"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Hāngai Tonu Whakatika LaTex"
  },
  "disable_preview_222bdf72": {
    "message": "Monokia Arokite"
  },
  "discussion_6719c51d": {
    "message": "Kōrerorero"
  },
  "discussions_a5f96392": {
    "message": "Ngā Kōrerorero"
  },
  "discussions_index_6c36ced": {
    "message": "Taupū Ngā Matapaki"
  },
  "disjoint_union_e74351a8": {
    "message": "Uniana wehe"
  },
  "display_options_315aba85": {
    "message": "Whakātuhia ngā Kōwhiringa"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Whakātuhia Kuputuhi Hononga (Ka hhuaki i roto i te ripa hou)"
  },
  "div_applied_49ad83fc": {
    "message": "I tono a Div"
  },
  "div_removed_d13f8e17": {
    "message": "Kua tangohia te Div"
  },
  "division_sign_72190870": {
    "message": "Waitohu wehewehe"
  },
  "document_678cd7bf": {
    "message": "Tuhinga"
  },
  "documents_81393201": {
    "message": "Ngā tuhinga"
  },
  "done_54e3d4b6": {
    "message": "Kua mahia"
  },
  "double_dagger_faf78681": {
    "message": "Matarua"
  },
  "down_5831a426": {
    "message": "Raro"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Pere Hauroki Raro Me Mauī"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Pere Hauroki Raro Me Matau"
  },
  "download_filename_2baae924": {
    "message": "Tikiake { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Pere Whakararo"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Tapatoru Tohu Whakararo"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Tō he kōnae ki konei"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Tōia me te taka, pāwhiri rānei ki te tirotiro tō rorohiko"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Tō kakau Whakamahi ngā pere runga raro ki te whakarerekē"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "E tika ana: Rā Maha"
  },
  "due_when_7eed10c6": {
    "message": "E tika ana: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Whakatikahia te kuputuhi alt mo tenei tauira ata"
  },
  "edit_c5fbea07": {
    "message": "Whakatika"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Whakatika Hononga Akoranga"
  },
  "edit_equation_f5279959": {
    "message": "Whakatika Tatauranga"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Whakatika Kei te noho Tohu Kaihanga Tohu"
  },
  "edit_icon_2c6b0e91": {
    "message": "Whakatika Ata"
  },
  "edit_link_7f53bebb": {
    "message": "Whakatika hononga"
  },
  "editor_status_bar_653f44ee": {
    "message": "Pae Tūnga Kaiwhakatika"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Te tīmatanga o te kaupapa { start }"
  },
  "embed_828fac4a": {
    "message": "Whakauru"
  },
  "embed_code_314f1bd5": {
    "message": "Waehere tāmau"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Whakauru ihirangi mai i te Taputapu o waho"
  },
  "embed_image_1080badc": {
    "message": "Tāmau Āhua"
  },
  "embed_video_a97a64af": {
    "message": "Whakauru Ataata"
  },
  "embedded_content_aaeb4d3d": {
    "message": "ihirangi tāmau"
  },
  "empty_set_91a92df4": {
    "message": "Tautuhi Putua"
  },
  "encircled_dot_8f5e51c": {
    "message": "Ira kua karapotia"
  },
  "encircled_minus_72745096": {
    "message": "Taawhiotia Minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Taawhiotia Tāpiri"
  },
  "encircled_times_5700096d": {
    "message": "Taiwhanga Taiwhanga"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Hangarau Tohu"
  },
  "english_icon_25bfe845": {
    "message": "Ingarihi Tohu"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Whakauruhia he taitara pāpāho"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Pātō ki iti ake i te 3 pūāhua hei rapu"
  },
  "enter_replacement_text_17631bbc": {
    "message": "tomo kupu whakakapi"
  },
  "enter_search_text_26cb4459": {
    "message": "tomo kupu rapu"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Tauke)"
  },
  "equals_sign_c51bdc58": {
    "message": "Waitohu Ōrite"
  },
  "equation_1c5ac93c": {
    "message": "Whārite"
  },
  "equation_editor_39fbc3f1": {
    "message": "Whārite Etita"
  },
  "equilibrium_6ff3040b": {
    "message": "Te toenga"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Karaehe Taurite"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ōrite (Taukiri)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Kei te noho"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Mono te Mata Katoa"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Whakawhānui arokite ma te Aunoa"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Whakawhānui ki te titiro { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Hononga a Waho"
  },
  "external_tool_frame_70b32473": {
    "message": "Anga taputapu o waho"
  },
  "external_tools_6e77821": {
    "message": "Taputapu o waho"
  },
  "extra_large_b6cdf1ff": {
    "message": "Nui rawa atu"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Tino Nui ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Tāpiri iti"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Extracurricular Tohu"
  },
  "f_function_fe422d65": {
    "message": "F (taumahi)"
  },
  "fail_544e5dde": {
    "message": "KORE"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "I rahua te whiwhi ihirangi kōnae"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "I rahua te tiki ihirangi mai i tetahi taputapu o waho"
  },
  "file_name_8fd421ff": {
    "message": "Ingoa kōnae"
  },
  "file_preview_21667a6e": {
    "message": "Arokite kōnae"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Arokite kōnae mō { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Te rokiroki kōnae motunga hipa"
  },
  "file_url_c12b64be": {
    "message": "Kōnae URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } kōnae icon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } āhua arokite"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } kuputuhi arokite"
  },
  "files_c300e900": {
    "message": "Kōnae"
  },
  "files_index_af7c662b": {
    "message": "Taupū kōnae"
  },
  "find_8d605019": {
    "message": "Kimihia"
  },
  "find_and_replace_6e345933": {
    "message": "Kimihia me te Whakakapi"
  },
  "finish_bc343002": {
    "message": "Mutu"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Whakatikahia te hiranga o te pane"
  },
  "flat_music_76d5a5c3": {
    "message": "Papa (Waiata)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Hāngai pūmotu kōwhiringa taputapu"
  },
  "folder_tree_fbab0726": {
    "message": "Rakau kōpaki"
  },
  "for_all_b919f972": {
    "message": "Mo te Katoa"
  },
  "format_4247a9c5": {
    "message": "Hōputu"
  },
  "format_as_a_list_142210c3": {
    "message": "Whakahōputu hei rārangi"
  },
  "formatting_5b143aa8": {
    "message": "Whakahōputu"
  },
  "forward_slash_3f90f35e": {
    "message": "Riiri Whakamua"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Kitea tiaki aunoa ihirangi"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Kitea { count, plural,\n     =0 {# ngā hua}\n    one {# hua i}\n  other {# ngā hua}\n}"
  },
  "fraction_41bac7af": {
    "message": "Hautau"
  },
  "fullscreen_873bf53f": {
    "message": "Mata katoa"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Hanga arokite ana ..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Ko nga whakaahua hōputu GIF/PNG nui ake I te { size } KB kaore I te tautokohia I tenei wa."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Haere ki te tahua papa o te etita"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Haere ki te paeutauta o te etita"
  },
  "grades_a61eba0a": {
    "message": "Ngā Kōeke"
  },
  "graphics_text_bc9568bc": {
    "message": "Kuputuhi whakairoiro"
  },
  "greater_than_e98af662": {
    "message": "Nui atu i"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Nui atu i te Ōrite ranei"
  },
  "greek_65c5b3f7": {
    "message": "Kariki"
  },
  "green_15af4778": {
    "message": "Kākāriki"
  },
  "grey_a55dceff": {
    "message": "Kerei"
  },
  "group_documents_8bfd6ae6": {
    "message": "Ngā Pukapuka roopu"
  },
  "group_files_4324f3df": {
    "message": "Ngā kōnae rōpū"
  },
  "group_files_82e5dcdb": {
    "message": "Ngā kōnae rōpū"
  },
  "group_images_98e0ac17": {
    "message": "Ngā āhua roopu"
  },
  "group_isomorphism_45b1458c": {
    "message": "Rōpū Isomorphism"
  },
  "group_link_63e626b3": {
    "message": "Hononga Rōpū"
  },
  "group_links_9493129e": {
    "message": "Ngā Hono Ropu"
  },
  "group_media_2f3d128a": {
    "message": "Pāpāho Roopu"
  },
  "group_navigation_99f191a": {
    "message": "Whakaterenga Rōpū"
  },
  "h_bar_bb94deae": {
    "message": "Pae H"
  },
  "hat_ea321e35": {
    "message": "Potae"
  },
  "header_column_f27433cb": {
    "message": "Pane pou"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Pane rārangi me te pou"
  },
  "header_row_f33eb169": {
    "message": "Pane rārangi"
  },
  "heading_2_5b84eed2": {
    "message": "Pane 2"
  },
  "heading_3_2c83de44": {
    "message": "Pane 3"
  },
  "heading_4_b2e74be7": {
    "message": "Pane 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Pane { h } tono"
  },
  "heading_h_removed_745f24a6": {
    "message": "Pane { h } tangohia"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Ko ngā taumata pane kaore e pekehia."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Pane e tīmata ana me { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Kia kaua ngā pane e nui atu i te 120 ngā reta."
  },
  "health_icon_8d292eb5": {
    "message": "Hauora Tohu"
  },
  "hearts_suit_e50e04ca": {
    "message": "Ngakau (Hutu)"
  },
  "height_69b03e15": {
    "message": "Teitei"
  },
  "hexagon_d8468e0d": {
    "message": "Tapaono"
  },
  "hide_description_bfb5502e": {
    "message": "Hunga taipitopito"
  },
  "hide_title_description_caf092ef": {
    "message": "Hunga { title } taipitopito"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Miramirahia he huānga hei whakahohe i te paeutauta kōwhiringa huānga"
  },
  "home_351838cd": {
    "message": "Kāinga"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Me pēhea te tono me te whakatika i ngā taitara?"
  },
  "html_code_editor_fd967a44": {
    "message": "html waehere editor"
  },
  "html_editor_fb2ab713": {
    "message": "Editor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Kua whiwhi ahau whakāetanga ki te whakamahi i tēnei kōnae."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Mau ahau te manatārua"
  },
  "icon_215a1dc6": {
    "message": "Icon"
  },
  "icon_8168b2f8": {
    "message": "Icon"
  },
  "icon_color_b86dd6d6": {
    "message": "Tohu Tae"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Tohu Kaihanga Ata"
  },
  "icon_options_7e32746e": {
    "message": "Kōwhiringa Ata"
  },
  "icon_options_tray_2b407977": {
    "message": "Paepae Kōwhiringa Ata"
  },
  "icon_preview_1782a1d9": {
    "message": "Arokite Ata"
  },
  "icon_shape_30b61e7": {
    "message": "Tohu Hanga"
  },
  "icon_size_9353edea": {
    "message": "Tohu Rahi"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Mēnā ka waiho pātea, ka whakaatu te kuputuhi hono hei ingoa hononga akoranga"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Mena ka hiahiatia nga motika whakamahi, karekau te konae e whakaputa kia taea ra ano ki te wharangi Kōnae."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Ki te kore koe e tīpako ngā mōtika whakamahi ināianei, kaore e whakaputaina tēnei kōnae i muri o ''te tukuake."
  },
  "image_8ad06": {
    "message": "Āhua"
  },
  "image_c1c98202": {
    "message": "āhua"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Kaua e whakamahia ngā kōnae ingoa ki te whakamahi i te alt huanga e whakātu ana i te ihirangi pakoko."
  },
  "image_options_5412d02c": {
    "message": "Ngā Kōwhiringa Āhua"
  },
  "image_options_tray_90a46006": {
    "message": "Te pereki mo ngā Kōwhiringa Āhua"
  },
  "image_to_crop_3a34487d": {
    "message": "Āhua he tapahi"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Āhua me te kōnae ingoa { file }"
  },
  "images_7ce26570": {
    "message": "Ngā Āhua"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Ko ngā āhua me whakauru he alt huanga e whakāhua ana i te ihirangi āhua"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Wahi Pohewa (o te Tau Matatini)"
  },
  "in_element_of_19ca2f33": {
    "message": "Kei roto (Huahanga o)"
  },
  "increase_indent_6af90f7c": {
    "message": "Nuku Whakanui"
  },
  "increase_rich_content_area_340b775": {
    "message": "Whakanuia te Rohe Ihirangi Taonga"
  },
  "indefinite_integral_6623307e": {
    "message": "Noa Tautoko"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } ō { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Whakataunga"
  },
  "infinity_7a10f206": {
    "message": "Mutunga"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Whakauru mara mo te alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Whakauru mara mo te kahurangi"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Whakauru mara mo te kakariki"
  },
  "input_field_for_red_86a84615": {
    "message": "Whakauru mara mo te whero"
  },
  "insert_593145ef": {
    "message": "Whakauru"
  },
  "insert_link_6dc23cae": {
    "message": "Whakauru hono"
  },
  "insert_math_equation_57c6e767": {
    "message": "Whakauru Math Whārite"
  },
  "integers_336344e1": {
    "message": "Tauoti"
  },
  "intersection_cd4590e4": {
    "message": "Whakawhitinga"
  },
  "invalid_description_991e23bb": {
    "message": "He whakaahuatanga muhu"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "He urunga muhu."
  },
  "invalid_file_c11ba11": {
    "message": "Muhu Kōnae"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Muhu kōnae momo"
  },
  "invalid_url_cbde79f": {
    "message": "URL muhu"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Take { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Whakairihia"
  },
  "italic_removed_17cbab6f": {
    "message": "Kua tangohia te titaha"
  },
  "kappa_2f14c816": {
    "message": "Kapa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kapa (Tauke)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Pokatata papapātuhi"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Ka whakaterehia e ngā papa pātuhi ngā hononga ki te whakamahi i Ripa kī. Ngā hononga e rua e tata ana e tika ana ki te haerenga rite ka pōraruraru ki ngā papa pātuhi kaiwhakamahi."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Reo Toi Tohu"
  },
  "languages_icon_9d20539": {
    "message": "Nga reo Tohu"
  },
  "large_9c5e80e7": {
    "message": "Nui"
  },
  "large_text_e7ba08cd": {
    "message": "Kuputuhi nui"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Nui ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Ako"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Ako ano i ngā hono tata"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Ako anō i ngā tae whakarerekē"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Ako anō i ngā whakahaere ngā pane whārangi"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Ako atu mo te hanganga pane wharangi tika"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Ako anō i ngā pane rārangi"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Ako anō i te mahi i ngā alt kuputuhi mo ngā āhua"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Ako anō i te mahi i ngā kōrero me ngā rārangi"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Ako anō i te mahi i ngā ingoa kōnae i te alt kuputuhi"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Ako anō i te mahi i ngā rārangi"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Ako anō i te mahi i ngā whānuitanga huanga me ngā rārangi"
  },
  "leave_as_is_4facfe55": {
    "message": "Waiho ki tēnei"
  },
  "left_3ea9d375": {
    "message": "maui"
  },
  "left_align_43d95491": {
    "message": "Tiaro Mauī"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Taiapa Koki Mauī"
  },
  "left_arrow_4fde1a64": {
    "message": "Pere Maui"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Pere Mauī Me te Matau"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Te tuanui maui"
  },
  "left_curly_brace_1726fb4": {
    "message": "Awhi Riiri Mauī"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Pere Harpoon Mauī ki raro"
  },
  "left_floor_29ac2274": {
    "message": "Papa Mauī"
  },
  "left_to_right_e9b4fd06": {
    "message": "Māui - ki te -Matau"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Pere Harpoon Whakarunga Mauī"
  },
  "leftward_arrow_1e4765de": {
    "message": "Pere Whakamaui"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Tapatoru Tohu Whakamaui"
  },
  "less_than_a26c0641": {
    "message": "Iti iho"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Iti I Te Ōrite ranei"
  },
  "library_icon_ae1e54cf": {
    "message": "Whare Pukapuka Tohu"
  },
  "light_blue_5374f600": {
    "message": "Puru marama"
  },
  "link_7262adec": {
    "message": "Hono"
  },
  "link_options_a16b758b": {
    "message": "Hono Kōwhiringa"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "momo hono: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Hono me te kuputuhi e tīmata ana me { start }"
  },
  "links_14b70841": {
    "message": "Hononga"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Hononga ki te pae o waho."
  },
  "lists_cd1336fc": {
    "message": "Nga rarangi"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Me whakaritehia ngā rārangi hei rārangi."
  },
  "load_more_35d33c7": {
    "message": "Tukuake nui atu"
  },
  "loading_25990131": {
    "message": "E uta ana ...."
  },
  "loading_bde52856": {
    "message": "E tukuake ana"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "utaina ana katia tapanga/kupu hauraro i rahua."
  },
  "loading_external_tool_d839042c": {
    "message": "Uta ana Taputapu Waho"
  },
  "loading_failed_b3524381": {
    "message": "I rahua te uta ..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "I hapa te utaina."
  },
  "loading_folders_d8b5869e": {
    "message": "E uta ana ngā kōpaki"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "E uta ana i te waahi mo { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "E Uta ana, tēnā koa tatari"
  },
  "loading_preview_9f077aa1": {
    "message": "Uta ana arokite"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Tere maukati i te 1x"
  },
  "locked_762f138b": {
    "message": "Kua rakaina"
  },
  "logical_equivalence_76fca396": {
    "message": "Whakaōrite arorau"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Ōritenga arorau (Poto)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Whakaōrite Ararau (Poro me te Matotoru)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Ōritenga arorau (Matotoru)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Ira Whakapae Iti"
  },
  "magenta_4a65993c": {
    "message": "Āhua waiporoporo"
  },
  "maps_to_e5ef7382": {
    "message": "Mahere Ki"
  },
  "math_icon_ad4e9d03": {
    "message": "Math Tohu"
  },
  "media_af190855": {
    "message": "Pāpāho"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Kei te tukatuka te konae pāpāho. Tēnā koa ngana anō i muri mai."
  },
  "media_options_saved_560c4ec8": {
    "message": "Kua tiakina ngā kōwhiringa pāpāho."
  },
  "media_title_2112243b": {
    "message": "Pāpāho Taitara"
  },
  "medium_5a8e9ead": {
    "message": "Kauwaka"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Waenga ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Whakapiri ngā hononga"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Kua Monokia Te Hopuoro"
  },
  "middle_27dc1d5": {
    "message": "Waenganui"
  },
  "minimize_file_preview_da911944": {
    "message": "Whakamōkito Arokitenga Kōnae"
  },
  "minimize_video_20aa554b": {
    "message": "Whakamōkito Ataata"
  },
  "minus_fd961e2e": {
    "message": "Minu"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Plus"
  },
  "misc_3b692ea7": {
    "message": "Misc"
  },
  "miscellaneous_e9818229": {
    "message": "Momo kē"
  },
  "module_90d9fd32": {
    "message": "Kōwae"
  },
  "modules_c4325335": {
    "message": "Kōwae"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Te neke atahanga ki te tapahi { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Whakapakoko nui ngā Tae"
  },
  "multiplication_sign_15f95c22": {
    "message": "Tohu Whakarea"
  },
  "music_icon_4db5c972": {
    "message": "Puoro Tohu"
  },
  "my_files_2f621040": {
    "message": "Aku kōnae"
  },
  "n_th_root_9991a6e4": {
    "message": "N-th Puaka"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Ingoa"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Taiao (Puoro)"
  },
  "natural_numbers_3da07060": {
    "message": "Tau Taiao"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Whakatere i roto i te tahua paeutauta rānei"
  },
  "navigation_ee9af92d": {
    "message": "Whakatere"
  },
  "nested_greater_than_d852e60d": {
    "message": "Nested Nui atu i"
  },
  "nested_less_than_27d17e58": {
    "message": "Kohanga Iti I Te"
  },
  "new_quiz_34aacba6": {
    "message": "Quiz Hou"
  },
  "next_40e12421": {
    "message": "E haere ake nei"
  },
  "next_findtext_9d69f0fe": {
    "message": "Tō muri mai { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Kaore he whakaurunga take i kitea."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Kare ano he panui i hanga."
  },
  "no_announcements_found_20185afc": {
    "message": "Karekau he panui i kitea."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Karekau he taumahi i hangaia."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Karekau he taumahi i kitea."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Kaore he huringa hei tiaki."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Karekau he korerorero i hanga."
  },
  "no_discussions_found_9284063b": {
    "message": "Karekau he korerorero i kitea."
  },
  "no_e16d9132": {
    "message": "Kahore"
  },
  "no_file_chosen_9a880793": {
    "message": "Kaore he kōnae i tīpakotia"
  },
  "no_headers_9bc7dc7f": {
    "message": "Kaore ngā pane"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Kaore ano kia hangahia nga waahanga."
  },
  "no_modules_found_2df43a40": {
    "message": "Karekau he waahanga i kitea."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Anō No whārangi hanga."
  },
  "no_pages_found_6799350": {
    "message": "Karekau he wharangi i kitea."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Ko te wātea hoki tēnei kōnae he arokite."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Kaore ano kia hangahia he patapatai."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Karekau he patapatai i kitea."
  },
  "no_results_940393cf": {
    "message": "Kaore he hua."
  },
  "no_results_found_58717065": {
    "message": "Kāore he hua i kitea"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Kaore i kitea he hua mo { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Kaore Ataata"
  },
  "none_3b5e34d2": {
    "message": "Kaore"
  },
  "none_selected_b93d56d2": {
    "message": "Kaore i Tīpakohia"
  },
  "normal_text_7b03da48": {
    "message": "Noa kuputuhi"
  },
  "not_equal_6e2980e6": {
    "message": "Ehara i te Ōrite"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Kaore i roto (Ehara i te Huanga o)"
  },
  "not_negation_1418ebb8": {
    "message": "Kore (Whakakore)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ehara i te Roopuiti"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ehara i te Waahanga Roopu (Paua)"
  },
  "not_superset_5556b913": {
    "message": "Ehara i te Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ehara i te Huinga Tuatoru (Paua)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Tapawaru"
  },
  "olive_6a3e4d6b": {
    "message": "Ōriwa"
  },
  "omega_8f2c3463": {
    "message": "Omeka"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Ko tetahi o nga momo e whai ake nei me taapiri hei tiaki i tetahi tohu Tohu Tae, Whakahuahua Rahi, Tohu Kuputuhi, ranei Whakaahua"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Kotahi neke atu ranei nga konae i rahua ki te whakapiri. Tena koa ngana ki te tuku, ki te toia me te tuku i nga konae."
  },
  "open_circle_e9bd069": {
    "message": "Porowhita Tuwhera"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Huaki tēnei pokatata papapātuhi kōrero"
  },
  "open_title_application_fd624fc5": {
    "message": "Huaki { title } tono"
  },
  "operators_a2ef9a93": {
    "message": "Ngā Kaiwhakamahi"
  },
  "options_3ab0ea65": {
    "message": "Kōwhiringa"
  },
  "or_9b70ccaa": {
    "message": "Rānei"
  },
  "orange_81386a62": {
    "message": "Ārani"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Rārangi kua rārangitia me te kore rārangi"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Ētahi atu etita pokatata i kitea ai"
  },
  "outline_color_3ef2cea7": {
    "message": "Tae Whakahuahua"
  },
  "outline_size_a6059a21": {
    "message": "Rahi Whakahuahua"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ehara i te kawa whaimana."
  },
  "page_50c4823d": {
    "message": "Whārangi"
  },
  "pages_e5414c2c": {
    "message": "Ngā Whārangi"
  },
  "paragraph_5e5ad8eb": {
    "message": "Parawae"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Kowae tono"
  },
  "paragraph_removed_d09320e": {
    "message": "Kua tangohia te whiti"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Parawae e tīmata ana me { start }"
  },
  "parallel_d55d6e38": {
    "message": "Whakarara"
  },
  "partial_derivative_4a9159df": {
    "message": "Wāhanga (Tautake)"
  },
  "pass_1c19a2b3": {
    "message": "PAAHI"
  },
  "paste_5963d1c1": {
    "message": "Whakapiri"
  },
  "pause_12af3bb4": {
    "message": "Okioki"
  },
  "pentagon_17d82ea3": {
    "message": "Tapaono"
  },
  "people_b4ebb13c": {
    "message": "Tāngata"
  },
  "percentage_34ab7c2c": {
    "message": "Ōrau"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Pai hēneti me nama anake"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Te ōrau me iti rawa { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Performing Arts Tohu"
  },
  "perpendicular_7c48ede4": {
    "message": "Tirohanga"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Tauke)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Tinana Mātauranga Tohu"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Taupe)"
  },
  "pick_a_color_557abfb0": {
    "message": "Tīpakohia he tae"
  },
  "pink_68ad45cb": {
    "message": "Māwhero"
  },
  "pixels_52ece7d1": {
    "message": "Ngā Pika"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Me iti rawa nga pika { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Tākaro"
  },
  "play_media_comment_35257210": {
    "message": "Purei korero pāpāho."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Whakatangihia nga korero pāpāho na { name } mai i { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Tahora kaitākaro"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Tēnā koa tukuna Canvas ki te whakauru i tō reooro me tō kāmera paetukutuku."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Kōwhiria he kōnae"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Tēnā koa whakauru he ingoa kōnae"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Whakaurua koa he URL ataata whaimana mai i te papaaho tautoko."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Tīpakohia koa tētahi kōnae he momo tautoko"
  },
  "plus_d43cd4ec": {
    "message": "Apiti atu"
  },
  "plus_minus_f8be2e83": {
    "message": "Tāpiri / Minus"
  },
  "posted_when_a578f5ab": {
    "message": "I Whakairia: { when }"
  },
  "power_set_4f26f316": {
    "message": "Tautuhi Mana"
  },
  "precedes_196b9aef": {
    "message": "Kei mua"
  },
  "precedes_equal_20701e84": {
    "message": "Tuhinga o mua Ōrite"
  },
  "preformatted_d0670862": {
    "message": "Tuhinga o mua"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Mua"
  },
  "preview_53003fd2": {
    "message": "Arokite"
  },
  "preview_a3f8f854": {
    "message": "AROKITE"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Arokite i roto i paparua"
  },
  "preview_inline_9787330": {
    "message": "Arokite i roto i te raina"
  },
  "previous_bd2ac015": {
    "message": "Ō muri"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Mua { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Ko nga tae kua tohua i mua"
  },
  "prime_917ea60e": {
    "message": "Pirimia"
  },
  "prime_numbers_13464f61": {
    "message": "Nga Nama Pirimia"
  },
  "product_39cf144f": {
    "message": "Hua"
  },
  "proportional_f02800cc": {
    "message": "Tauritenga"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Ko te tikanga me ftp, http, https, mailto, skype, tel ara me mihi rānei"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "whakaputaina"
  },
  "published_when_302d8e23": {
    "message": "Whakaputaina: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Paukena"
  },
  "purple_7678a9fc": {
    "message": "Waiporoporo"
  },
  "quaternions_877024e0": {
    "message": "Nga hauwha"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Ngā Quizzes"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Tau Tikanga"
  },
  "real_numbers_7c99df94": {
    "message": "Nga Tau Tuturu"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Wahi Tuturu (o te Tau Matatini)"
  },
  "record_7c9448b": {
    "message": "Tāhopu"
  },
  "record_upload_media_5fdce166": {
    "message": "Tāhopu/Kaweake Pāpāho"
  },
  "recording_98da6bda": {
    "message": "Hopukanga"
  },
  "red_8258edf3": {
    "message": "Whero"
  },
  "relationships_6602af70": {
    "message": "Ngā whanaungatanga"
  },
  "religion_icon_246e0be1": {
    "message": "Whakapono Tohu"
  },
  "remove_f47dc62a": {
    "message": "Neke"
  },
  "remove_filename_3ea029f6": {
    "message": "Tango { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Tango pane kāhua"
  },
  "remove_link_d1f2f4d0": {
    "message": "Tango Hononga"
  },
  "replace_all_d3d68b3": {
    "message": "Whakakapi Katoa"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Whakakapi katoa { findText } me { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Whakakapi"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Whakakapi { findText } me { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Whakakapi me"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Kua whakakapia { alertFindText } me { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "I whakakapi katoa { alertFindText } me { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Tautuhi anō"
  },
  "resize_ec83d538": {
    "message": "Rahi anō"
  },
  "restore_auto_save_deccd84b": {
    "message": "Whakaora tiaki aunoa?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Hua { index } o { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Hurihuri Whakamuri (Kare e Tuku)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Tauke)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Ētita Ihirangi Whai Rawa"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Horahanga Kupu Taunaki. Perehi { OSKey }+F8 mo nga pokatata o te Kaiwhakatika Ihirangi Taonga."
  },
  "right_71ffdc4d": {
    "message": "Matau"
  },
  "right_align_39e7a32a": {
    "message": "Tiaro Matau"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Taiapa Koki Matau"
  },
  "right_arrow_35e0eddf": {
    "message": "Pere Matau"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Pere Matau Me te Matau"
  },
  "right_ceiling_839dc744": {
    "message": "Taurangi Matau"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Awhi Riiri Matau"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Pere Harpoon Matau Whakararo"
  },
  "right_floor_5392d5cf": {
    "message": "Papa Matau"
  },
  "right_to_left_9cfb092a": {
    "message": "Matau - ki te - Māui"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Pere Hapapa Matau Whakarunga"
  },
  "rightward_arrow_32932107": {
    "message": "Pere Matau"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Tapatoru Tohu Whakamatau"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Hurihia te ahua -90 nga nekehanga"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Hurihia te ahua 90 nga nekehanga"
  },
  "rotation_9699c538": {
    "message": "Te hurihanga"
  },
  "row_fc0944a7": {
    "message": "Rārangi"
  },
  "row_group_979f5528": {
    "message": "Rōpū rārangi"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "E pouri ana te ataahua HTML kaore i te papa patopato whakauru. Whakauru te mata HTML editor ataahua i konei."
  },
  "save_11a80ec3": {
    "message": "Tiaki"
  },
  "save_copy_ca63944e": {
    "message": "Tiakina kape"
  },
  "save_media_cb9e786e": {
    "message": "Tiaki Pāpāho"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Kua tiakina Tohu Kaihanga Tohu"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Kaore e taea e ngā kaipānui mata te whakatau i ngā mea e whakātuhia ana i roto i te āhua me te kore kuputuhi rerekē, a, he maha ngā taura o ngā tau me ngā reta kaore i te whakāhua i te horopaki te tikanga rānei."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Kaore e taea e ngā kaipānui mata te whakatau i ngā mea e whakāturia ana i roto i te āhua me te kore kuputuhi rerekē, e whakātu ana i te ihirangi me te tikanga o te pakoko. Me ngāwari me te hāngai tōtika te kuputuhi rerekē."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Kaore e taea e ngā kaipānui mata te whakatau i ngā mea e whakāturia ana i roto i te āhua me te kore kuputuhi rerekē, e whakātu ana i te ihirangi me te tikanga o te pakoko."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Kaore e taea e ngā kaipānui mata ki te whakamāori i ngā papa kaore te hanganga tika. Ko ngā pane ripanga e whakarato ana i te aronga me te kohinga ihirangi."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Kaore e taea e ngā kaipānui mata ki te whakamāori i ngā papa kaore te hanganga tika. Ko ngā panuku tapanga e whakaatu ana i te horopaki me te mātauranga whānui o te ripanga."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Kaore e taea e ngā kaipānui mata ki te whakamāori i ngā papa kaore te hanganga tika. Ko ngā pane ripanga whakarato ana i te ahunga me te tirohanga o te ihirangi."
  },
  "script_l_42a7b254": {
    "message": "Hōtuhi L"
  },
  "search_280d00bd": {
    "message": "Rapu"
  },
  "select_audio_source_21043cd5": {
    "message": "Tīpakohia ororongo puna"
  },
  "select_crop_shape_d441feeb": {
    "message": "Tīpako tapahi āhua"
  },
  "select_language_7c93a900": {
    "message": "Tīpako Reo"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Tīpakohia ataata puna"
  },
  "selected_274ce24f": {
    "message": "Kua tīpakohia"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Tīpakohia { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Tīpakonga"
  },
  "set_header_scope_8c548f40": {
    "message": "Whakatau horopaki pane"
  },
  "set_minus_b46e9b88": {
    "message": "Tautuhi Minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Whakatau pane ripanga"
  },
  "sharp_music_ab956814": {
    "message": "Koi (Puoro)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Pere"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Neke O ki te huaki ataahua html etita."
  },
  "shortcut_911d6255": {
    "message": "Pokatata"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Whakātu wāhanga āhua"
  },
  "show_link_options_545338fd": {
    "message": "Whakātu Hono Kōwhiringa"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Whakaatuhia te tuhinga hurihuri"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Whakaatuhia te tuhinga hurihuri"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Ngā kaiwhakamahi e āhei ana ki te tiro pūtirotiro tere i te ngā whārangi tukutuku, me te rapu i ngā pane nui, maia rānei. Ka whakawhirinaki ngā kaiwhakamahi pānui mata ki ngā pane mo te māramatanga o te horopaki. Me whakamahi ngā pane i te hanganga tika."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Ngā kaiwhakamahi e āhei ana ki te tiro pūtirotiro tere i te ngā whārangi tukutuku, me te rapu i ngā pane nui, maia rānei. Ka whakawhirinaki ngā kaiwhakamahi pānui mata ki ngā pane mo te māramatanga o te horopaki. Me whai kiko ngā pane ki roto i te hanganga tika."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Taupe)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Whakapakoko kotahi te Tae"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Takakau Tae Whakaahua Tae"
  },
  "size_b30e1077": {
    "message": "Rahi"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Te rahi o te tapanga kōnae nui ake i te mōrahi { max } kb tukua rahi kōnae rahi."
  },
  "small_b070434a": {
    "message": "Iti"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Iti ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Porowhita Mārō"
  },
  "something_went_wrong_89195131": {
    "message": "I hē tētahi mea."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "I hapa i te wā e uru ana i tō paetukutuku kāmera"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "I raruraru tētahi mea me taku kore e mōhio he aha te mea hei whakātu ki a koe."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "I hē tētahi mea. Tirohia to hononga, utaina ano te wharangi, ka ngana ano."
  },
  "something_went_wrong_d238c551": {
    "message": "I raruraru tētahi mea"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "He hapa i te wā e tuari ana i tō mata."
  },
  "sort_by_e75f9e3e": {
    "message": "Wehewehe e"
  },
  "spades_suit_b37020c2": {
    "message": "Haka (Hutu)"
  },
  "square_511eb3b3": {
    "message": "Tapawha"
  },
  "square_cap_9ec88646": {
    "message": "Potae Tapawha"
  },
  "square_cup_b0665113": {
    "message": "Kapu tapawha"
  },
  "square_root_e8bcbc60": {
    "message": "Putake tapawha"
  },
  "square_root_symbol_d0898a53": {
    "message": "Tohu Putake Tapawha"
  },
  "square_subset_17be67cb": {
    "message": "Roopuiti tapawha"
  },
  "square_subset_strict_7044e84f": {
    "message": "Roopu Waahanga Tapawha (Paua)"
  },
  "square_superset_3be8dae1": {
    "message": "Tapawha Superset"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Huinga Tuatoru Tapawha (Paua)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "Tapawhā rārangi kore"
  },
  "star_8d156e09": {
    "message": "Whetū"
  },
  "start_over_f7552aa9": {
    "message": "Tīmata Anō"
  },
  "start_recording_9a65141a": {
    "message": "Timata te hopu ana"
  },
  "steel_blue_14296f08": {
    "message": "Te rino Kahurangi"
  },
  "studio_media_options_ee504361": {
    "message": "kōwhiringa pāpāho studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Paepae Kōwhiringa Papapāho Studio"
  },
  "styles_2aa721ef": {
    "message": "Ngā Kāhua"
  },
  "submit_a3cc6859": {
    "message": "Tuku"
  },
  "submitting_b90fac62": {
    "message": "E tuku ana...."
  },
  "subscript_59744f96": {
    "message": "Tuhinga"
  },
  "subset_19c1a92f": {
    "message": "Roopuiti"
  },
  "subset_strict_8d8948d6": {
    "message": "Roopuiti (Paua)"
  },
  "succeeds_9cc31be9": {
    "message": "Ka angitū"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Ka Angitu Ōrite"
  },
  "sum_b0842d31": {
    "message": "Huihuinga"
  },
  "superscript_8cb349a2": {
    "message": "Tuhinga nui"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Tuhituhi me te Tuhituhi"
  },
  "superset_c4db8a7a": {
    "message": "Hupiripiri"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Maua)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Ngā kōnae momo kua tautokotia: SRT me WebVTT rānei"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Hurihia ki te Kaiwhakatika HTML ataahua"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Huri ki te Kaiwhakatika HTML mata"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Huri ki te mata html ētita"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Huri ki te whai rawa kuputuhi ētita"
  },
  "syllabus_f191f65b": {
    "message": "Marautanga"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Punaha Oro Whakaaetia"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Punaha Oro Monokia"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/ngā pere"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Ka timata te pane ripanga mei te { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Ripanga e timata ana me { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Me tautuhi ngā pane ripanga ki te whakaputa te hōkai."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Me whakauru ngā ripanga ki tētahi tuhinga e whakaatu ana i ngā ihirangi o te ripanga."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Me whakauru ngā ripanga i te iti rawa o te pane kotahi."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Tira"
  },
  "text_7f4593da": {
    "message": "Kuputuhi"
  },
  "text_background_color_16e61c3f": {
    "message": "Kuputuhi Papamuri Tae"
  },
  "text_color_acf75eb6": {
    "message": "Kuputuhi tae"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "He uaua te panui, kaore he rerekētanga i waenga i te tuhinga me te papamuri, ina koa mo te hunga e iti ana te kite."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Ko te kuputuhi nui ake i te 18pt (me te maia 14pt) me whakātu i te ōwehenga rerekē iti o te 3: 1."
  },
  "text_optional_384f94f7": {
    "message": "Kuputuhi (kōwhiringa)"
  },
  "text_position_8df8c162": {
    "message": "Kuputuhi Tūnga"
  },
  "text_size_887c2f6": {
    "message": "Kuputuhi Rahi"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Ko te kuputuhi iti atu i te 18pt (me te maia 14pt) me whakātu i te ōwehenga rerekē iti o te 4.5: 1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Kei te tukatuka i tēnei wā te arokite tuhinga. Tēnā koa ngana anō i muri mai."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Ko te pane tuatahi o te wharangi me H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Kua heke te teitei o te Rohe Ihirangi Taonga."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Kua piki ake te teitei o te Rohe Ihirangi Taonga."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Ko te rauemi kei roto i te rohe tūmatanui"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Raihanatia te rauemi i raro i te Auaha Noa"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "He kaupapa ngā rauemi ki te rerekētanga - hei tauira whakamahi tika, te tika ki te whakahoke, ētahi atu rānei i raro i ngā manatārua ture e hāngai ana"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Te ataahua HTML kaore i te papa patopato whakauru. Pēhi Neke O ki te huaki mata html etita."
  },
  "therefore_d860e024": {
    "message": "No reira"
  },
  "theta_ce2d2350": {
    "message": "Teta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Tauke)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Pere Whakararo Matotoru"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Mātotoru Mauī Pere"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Mātotoru Whakataha maui Pere"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Mātotoru Matau Pere"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Mātotoru Matau paroita Pere"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Mātotoru Ki runga paroita Pere"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "E kore e taea te whakaatu i tēnei tuhinga i roto i Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "IWhakuru whārite"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Kaore tēnei āhua i te wātea i tēnei wā"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Ka whakaatu pea tenei ataata i nga panui YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Ahakoa tō ataata te taitara tika i roto i te tirotiro, i hapa te whakahou i roto i te pātengi raraunga."
  },
  "thumbnail_e0de666f": {
    "message": "Karakōnui"
  },
  "timebar_a4d18443": {
    "message": "Tapareti"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Kāore e taea te noho kau te taitara"
  },
  "title_ee03d132": {
    "message": "taitara"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Hei whakairi: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Hei Mahi: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Takahuri { summary } roopu"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Takahuri taputapu"
  },
  "tools_2fcf772e": {
    "message": "Ngā Taputapu"
  },
  "top_66e0adb6": {
    "message": "Runga"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Kei te wātea te papa tuhinga mō ngā whānui neke atu i te 720px."
  },
  "tray_839df38a": {
    "message": "Pereki"
  },
  "triangle_6072304e": {
    "message": "Tapatoru"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Takahuri (Nga Hua)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "patopato Control F9 ki te whakauru ngā kōwhiringa āhua. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "patopato Control F9 ki te whakauru ngā kōwhiringa hono. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "patopato Control F9 ki te whakauru ngā kōwhiringa ripanga. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Kaore e taea te whakatau url whiriwhiri rauemi"
  },
  "underline_applied_ae01ec97": {
    "message": "Tararo i hoatu"
  },
  "underline_removed_3693e17c": {
    "message": "Kua tangohia te tararo"
  },
  "union_e6b57a53": {
    "message": "Uniana"
  },
  "unpublished_dfd8801": {
    "message": "kaore i pānuitia"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Ka ngaro ngā huringa kāore anō kia tiakina."
  },
  "untitled_16aa4f2b": {
    "message": "Taitara kore"
  },
  "untitled_efdc2d7d": {
    "message": "taitara kore"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Ki runga Na Mauī Hauroki Pere"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Ki runga Na Matau Hauroki Pere"
  },
  "up_c553575d": {
    "message": "Ake"
  },
  "updated_link_a827e441": {
    "message": "Hononga kua whakahoutia"
  },
  "upload_document_253f0478": {
    "message": "Tikiake Tuhinga"
  },
  "upload_file_fd2361b8": {
    "message": "Tukuake kōnae"
  },
  "upload_image_6120b609": {
    "message": "Tukuake Whakāturanga"
  },
  "upload_media_ce31135a": {
    "message": "Tukuatu pāpāho"
  },
  "upload_record_media_e4207d72": {
    "message": "Tukuatu/Tāhopu Pāpāpho"
  },
  "uploading_19e8a4e7": {
    "message": "E tikiake ana"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "Wakapū teitei rārangi kua rārangitia"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Pūmatua Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Pūmatua Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Pūmatua Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Pūmatua Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Pūmatua Ph"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pūmatua Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Pūmatua Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "Roman tātai teitei kua rārangitia"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Pūmatua Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Pūmatua Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Pūmatua Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Pūmatua Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Pere Tohu Whakarunga, Whakararo"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Pere Tohu Whakarunga, Whakararo (Matotoru)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Pere Whakarunga"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Tapatoru Tohu Whakarunga"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Tika mo te whakamahinga:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Tika mo te whakamahinga (e hiahiatia ana)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Whakamahia ngā kī pere pere hei whakawhiti i nga wāhanga."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Mahia ngā kī pero ki te tīpako he āhua."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Mahia ngā kī pero ki te tīpako he rahi."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Mahia ngā kī pero ki te tīpako he kuputuhi tūnga."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Mahia ngā kī pero ki te tīpako he kuputuhi rahi."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Mahia ngā kī pero ki te tīpako he whakahuahua rahi."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Ka whakamahia e te hunga panui mata ki te whakaahua i nga ihirangi o te { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Whakamahia e ngā kaipānui mata hei whakāhua i ngā ihirangi o te āhua"
  },
  "user_documents_c206e61f": {
    "message": "Kaiwhakamahi Tuhinga"
  },
  "user_files_78e21703": {
    "message": "Ngā Kaiwhakamahi Kōnae"
  },
  "user_images_b6490852": {
    "message": "Ngā Āhua O Ngā Kaiwhakamahi"
  },
  "user_media_14fbf656": {
    "message": "Kaiwhakamahi Pāpāho"
  },
  "vector_notation_cf6086ab": {
    "message": "Vector (Tuhinga)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Pae Poutū (Tautuhi Tohu Kaihanga)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Poutū Ira"
  },
  "video_options_24ef6e5d": {
    "message": "Ataata Kōwhiringa"
  },
  "video_options_tray_3b9809a5": {
    "message": "Ataata Kōwhiringa Pereki"
  },
  "video_player_b371005": {
    "message": "Kaitākaro Ataata"
  },
  "video_player_for_9e7d373b": {
    "message": "Kaitākaro Ataata mō "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Kaitākaro Ataata mō { title }"
  },
  "video_url_889d3263": {
    "message": "URL Ataata"
  },
  "view_all_e13bf0a6": {
    "message": "Titiro ki te Katoa"
  },
  "view_ba339f93": {
    "message": "Tirohia"
  },
  "view_description_30446afc": {
    "message": "Tirohia te whakāturanga"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Titiro npapa patopato tapahi poto"
  },
  "view_title_description_67940918": {
    "message": "Tirohia { title } te whakāturanga"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Tatauhia nga kupu me nga tohu."
  },
  "viewer_restrictions_e14274c9": {
    "message": "Nga Rahui Kaitirotiro"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Kaore i kitea he orooro e mahi ana e hono ana ki tō pūrere."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Kaore i kitea he ipurangi kāmera e hono ana ki tō pūrere."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Kaore i kitea he ipurangi kāmera ara orooro hono ki tō pūrere."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam Monokia"
  },
  "webcam_fe91b20f": {
    "message": "Paetukutuku Kāmera"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Ko nga wharangi Tukutuku kia kotahi anake te H1, ka whakamahia aunoatia e te Taitara o te wharangi. Ko te pane tuatahi o to ihirangi me H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Ina whakamahia te tohu tohu i ngā taonga tautuhi tirohanga hei rārangi, ēngari kaore e tohu i te hononga o te rārangi, he uaua ki ngā kaiwhakamahi te whakawhiti i ngā kōrero."
  },
  "white_87fa64fd": {
    "message": "Ma"
  },
  "why_523b3d8c": {
    "message": "He aha"
  },
  "width_492fec76": {
    "message": "Te whānuitanga"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Te whānuitanga me te teitei me mahi hei nama"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Kainga"
  },
  "word_count_c77fe3a6": {
    "message": "Kupu Kaute"
  },
  "words_b448b7d5": {
    "message": "Kupu"
  },
  "wreath_product_200b38ef": {
    "message": "Te karaehe Hua"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ae"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Kei runga koe i te papanga tae. Hei whakatere i runga i te papatae ki runga, maui, whakararo, matau ranei, whakamahia nga paatene ''W'', ''A'', ''S'' me te ''D''."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Kei runga koe i te rēreti tae. Hei whakatere i te rēreti ki te taha maui, ki te taha matau ranei, whakamahia nga paatene ''A'' me te ''D''"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Kei runga koe i te rēreti alpha. Hei whakatere i te rēreti ki te taha maui, ki te taha matau ranei, whakamahia nga paatene ''A'' me te ''D''"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "He huringa kare ano koe i tiakina i roto i te Paepae Kaihanga Ata. Me haere tonu me te kore e tiaki i enei huringa?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Ka hiahia pea koe ki te whakatika i etahi atu pane ki te pupuri i te arorangi wharangi."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Kaore koe e taea te tikiake he kōnae kore"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Kua kōpekehia to ahua mo te Kaihanga Ata. Ko nga whakaahua iti iho I te { size } KB e kore e kōpeketia."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Kua aukatitia tō orooro i roto i te tautuhinga tirotiro."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Tō ipurangi kāmera me tō orooro kua aukatitia i roto i te tautuhinga tirotiro."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Tō ipurangi kāmera kua aukatitia i roto i te tirotiro tautuhinga."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Kei te whakamahia pea tō paetukutuku kāmera."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube whakauru URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Topa"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Topa mai whakaahua"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Topa ki waho whakaahua"
  }
};
formatMessage.addLocale({
  mi: locale
});